var map = {
	"./Cooky_lvl5_15_09_2022": 95,
	"./Cooky_lvl5_15_09_2022.json": 95,
	"./Druid_lvl5_16_09_2022": 96,
	"./Druid_lvl5_16_09_2022.json": 96,
	"./Dual wielding Warrior_lvl5_11_08_2022": 97,
	"./Dual wielding Warrior_lvl5_11_08_2022.json": 97,
	"./Sorcerer_lvl5_16_09_2022": 98,
	"./Sorcerer_lvl5_16_09_2022.json": 98,
	"./Swashbuckler_lvl5_11_08_2022": 99,
	"./Swashbuckler_lvl5_11_08_2022.json": 99,
	"./shooter_lvl5_11_08_2022": 100,
	"./shooter_lvl5_11_08_2022.json": 100,
	"./wrestler_lvl5_11_08_2022": 101,
	"./wrestler_lvl5_11_08_2022.json": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 181;